var React = require('react');

function CrossInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.933 8.5L15 13.567 13.567 15 8.5 9.933 3.433 15 2 13.567 7.067 8.5 2 3.433 3.433 2 8.5 7.067 13.567 2 15 3.433 9.933 8.5z","fill":"currentColor"}));
}

CrossInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = CrossInline;

CrossInline.default = CrossInline;
